/**********************************
 *   Subscription Alert Upgrade   *
 **********************************/

(function() {
  'use strict';
  
  var dvAlertWrapper = null;
  var dvAlert = null;
  var planUpgrade = null;
  
  var defineUpgrade = function(plans) {
    for(var i in plans) {
      var plan = plans[i];
      
      if(plan.current !== true) {
        planUpgrade = plan;
        break;
      }
    }
  };
  
  var renderAlert = function() {
    dvAlertWrapper = document.createElement('div');
    dvAlertWrapper.setAttribute('id', 'alert-upgrade--wrapper');
    dvAlertWrapper.classList.add('modal--wrapper');
    
    dvAlert = document.createElement('div');
    dvAlert.setAttribute('id', 'alert-upgrade');
    dvAlert.classList.add('upgrade-modal');
    
    var dvClose = document.createElement('div');
    dvClose.setAttribute('id', 'close-modal');
    dvClose.classList.add('close-modal');
    
    dvClose.addEventListener('click', closeAlert);    

    var imgClose = new Image();
    imgClose.src = '//cdn.shopify.com/s/files/1/2395/7099/t/82/assets/cross-popup-black.svg?v=150627539309535540611654532370';
    
    dvClose.appendChild(imgClose);
    
    dvAlert.appendChild(dvClose);
    
    var h2Title = document.createElement('h2');
    
    var txH2Pre = document.createTextNode('Get saved boards for $1/month');

    /*var spTitle = document.createElement('span');
    var txTitle = document.createTextNode(planUpgrade.displayed_features.display_name);
    spTitle.appendChild(txTitle);*/

    // var txH2Pos = document.createTextNode(' plan');

    h2Title.appendChild(txH2Pre);
    // h2Title.appendChild(spTitle);
    //h2Title.appendChild(txH2Pos);

    dvAlert.appendChild(h2Title);

    /*var dvDescription = document.createElement('div');
    dvDescription.setAttribute('id', 'alert-description');
    dvDescription.classList.add('alert-description');

    var txDescription = document.createTextNode(planUpgrade.displayed_features.upgrade_description);

    dvDescription.appendChild(txDescription);

    dvAlert.appendChild(dvDescription);*/

    var btnViewPlans = document.createElement('button');
    btnViewPlans.classList.add('btn-upgrade');

    var txViewPlans = document.createTextNode('Upgrade');
    btnViewPlans.appendChild(txViewPlans);
    
    btnViewPlans.addEventListener('click', function() {
      location.href = '/account?view=subscription';
    });
    
    dvAlert.appendChild(btnViewPlans);

    dvAlertWrapper.appendChild(dvAlert);
    
    dvAlertWrapper.style.display = 'block';
    
    document.body.appendChild(dvAlertWrapper);
    
    setTimeout(function() {
      window.addEventListener('click', clickedOutAlert);
    }, 100);
  };
  
  var clickedOutAlert = function(e) {
    if (dvAlert && !dvAlert.contains(e.target)) {
      closeAlert();
    }
  };
  
  var closeAlert = function(e) {
  	document.body.removeChild(dvAlertWrapper);
    
    dvAlert = null;
    dvAlertWrapper = null;
    
  	window.removeEventListener('click', clickedOutAlert);
  };
    
  document.addEventListener('customer_upgrades_loaded', function(e) {
    defineUpgrade(e.detail.plans);
  });
  
  document.addEventListener('alert_upgrade_requested', renderAlert);
  
  var requestUpgradesEvent = new CustomEvent("customer_upgrades_requested");
  document.dispatchEvent(requestUpgradesEvent);
  
})();